import { sorteColum } from './columnSearch';
import oMultiDiff from './oMultiDiff.json';
import strChineseFirstPY from './strChineseFirstPY.json';
// import pageoffice from 'http://10.10.101.96:8899/qms/demo/api/pageoffice.js'
// import pageoffice from './pageoffice.js';
// console.log('222',pageoffice.POBrowser)
// pageoffice.POBrowser

export { oMultiDiff, strChineseFirstPY };
export const centeColumn = [
  {
    title: '分拨名称',
    dataIndex: 'name',
  },
  {
    title: '分拨编号',
    dataIndex: 'code',
  },
];
export const provinceColumn = [
  {
    title: '省区名称',
    dataIndex: 'name',
  },
  {
    title: '省区编号',
    dataIndex: 'code',
  },
];

export const centeColumnPel = [
  {
    title: '站台名称',
    dataIndex: 'name',
  },
  {
    title: '站台编号',
    dataIndex: 'code',
  },
];
export const userColumn = [
  {
    title: '员工名称',
    dataIndex: 'name',
  },
  {
    title: '员工编号',
    dataIndex: 'code',
  },
];
export const columns2 = [
  {
    title: '上报人',
    dataIndex: 'name',
  },
  {
    title: '上报人编号',
    dataIndex: 'code',
  },
];
export const columns3 = [
  {
    title: '责任人',
    dataIndex: 'name',
  },
  {
    title: '责任人编号',
    dataIndex: 'code',
  },
];

export const aggreColumn = [
  {
    title: '票数',
    dataIndex: 'ticket',
    align: 'center',
    sorter: sorteColum('ticket'),
    render: (t) => (t && Math.abs(t)) || '',
  },
  {
    title: '件数',
    dataIndex: 'piece',
    align: 'center',
    sorter: sorteColum('piece'),
    render: (t) => (t && Math.abs(t)) || '',
  },
  {
    title: '重量',
    dataIndex: 'goodsWeight',
    align: 'center',
    defaultSortOrder: 'descend',
    sorter: sorteColum('goodsWeight'),
    render: (t) => (t && (Math.abs(t) / 1000).toFixed(2)) || '',
  },
  {
    title: '体积',
    dataIndex: 'goodsVolume',
    align: 'center',
    sorter: sorteColum('goodsVolume'),
    render: (t) => (t && Math.abs(t).toFixed(2)) || '',
  },
];

export function removeSuffix(center) {
  if (center && center.slice(center.length - 4, center.length) === '分拨中心') {
    center = center.slice(0, center.length - 4);
  }
  return center;
}

export const mapColumn = (name) => {
  return [
    {
      title: `${name}编号`,
      dataIndex: 'code',
    },
    {
      title: `${name}名称`,
      dataIndex: 'name',
    },
    {
      title: `${name}拼音`,
      dataIndex: 'py',
    },
  ];
};

export const mapColumn2 = ({ name, codeIndex = 'code', nameIndex = 'name', pyIndex = 'py' }) => {
  return [
    {
      title: `${name}编号`,
      dataIndex: codeIndex,
    },
    {
      title: `${name}名称`,
      dataIndex: nameIndex,
    },
    {
      title: `${name}拼音`,
      dataIndex: pyIndex,
    },
  ];
};
